import { useEffect, useState, useRef } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../store/user/user.selector";
import { selectShowcaseCardsById } from "../../store/showcase/showcase.selector";
import { fetchAndSetShowcaseCards } from "../../utils/firebase/showcase";

// styles
import {
  ShowcaseContainerContainer
} from "./ShowcaseContainer.styles";

export default function Showcase() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const cardsById = useSelector(selectShowcaseCardsById);
  const hasFetchedRef = useRef(false);
  const hasCards = Boolean(cardsById && Object.keys(cardsById).length > 0);
  const [cardsResolved, setCardsResolved] = useState(hasCards);

  useEffect(() => {
    if (!user?.uid) return undefined;

    if (hasCards) {
      hasFetchedRef.current = true;
      setCardsResolved(true);
      return undefined;
    }

    if (hasFetchedRef.current) return undefined;

    hasFetchedRef.current = true;
    fetchAndSetShowcaseCards(user.uid, dispatch)
      .catch(() => {
        // Leave the pool empty and let the carousel show its empty state.
      })
      .finally(() => setCardsResolved(true));

    return undefined;
  }, [dispatch, user?.uid, hasCards]);

  return (
    <ShowcaseContainerContainer className='widget-bg'>
      <Outlet context={{ cardsResolved }} />
    </ShowcaseContainerContainer>
  );
}